import { NgModule, NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
//import { AngularResizedEventModule } from 'angular-resize-event';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { OpenComponent } from './open/open.component';
import { HttpClientModule } from '@angular/common/http';

import { AboutComponent } from './about/about.component';

import {A11yModule} from '@angular/cdk/a11y';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {Portal, PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';

import {TimeKeeperService}   from './time-keeper.service';
import {Events} from './Events.service';
import {Melody} from './melody';
import { InAppPurchase2} from '@ionic-native/in-app-purchase-2/ngx';
import { AppConfigService } from './app-config.service';
import { Usage, UsageService } from './usage.service';
import { Capacitor } from '@capacitor/core';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import {NgxSliderModule} from 'ngx-slider-v2';
@NgModule({
    declarations: [
        AppComponent, OpenComponent,AboutComponent
    ],
    imports: [HttpClientModule, BrowserModule,
        IonicModule.forRoot(), AppRoutingModule,
        BrowserAnimationsModule, DragDropModule,
        A11yModule,
        ClipboardModule,
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule,
        DragDropModule,
        PortalModule,
        ScrollingModule,
NgxGoogleAnalyticsModule.forRoot('G-TQ83BHXZHJ'),
//NgxGoogleAnalyticsModule.forRoot('G-TWL2TCZPTT'),

   // Capacitor.getPlatform()=='web'?NgxGoogleAnalyticsModule.forRoot('G-TQ83BHXZHJ'):NgxGoogleAnalyticsModule.forRoot('G-TWL2TCZPTT'),

    NgxGoogleAnalyticsRouterModule,
    NgxSliderModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA
    ],
    providers: [
        InAppPurchase2,
        StatusBar,
        TimeKeeperService,
        Melody,
        AppConfigService,
        Events,
        UsageService,
     
        SplashScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
